import React from 'react';
import '../style/profile.scss';
import Profile from '../layouts/Profile';

export default function ShowUserProfile(props) {
    var employee = props.employee;
    return < Profile employee={employee} fromUsers={props.fromUsers} />;
}
